
import { defineComponent } from 'vue';

const component = defineComponent({
  name: 'sceneDesignMainHeader',
  props: {
    headerText: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    return { ...props };
  },
});

export default component;
